import i18next from 'i18next'

import { ValidateFormService } from 'services/ValidateFormService'
import { getSharedKey } from 'utils/helpers/i18n/getKeys'

import { MIN_DESCRIPTION_LENGTH, TicketKeys } from '../../data'
import { CreateTicketUiStore } from '../../stores/CreateTicketUiStore'
import { TicketType } from '../../types'

const getKey = (key: string) => `${TicketKeys.createTicket}.validate.${key}`

export class ValidateTicketForm extends ValidateFormService {
  validate = (uiStore: CreateTicketUiStore) => {
    const errors: string[] = []

    if (uiStore.ticketTypeValue === TicketType.openingOrder) {
      if (uiStore.description.trim().length < MIN_DESCRIPTION_LENGTH) {
        errors.push(i18next.t(getKey('ticketDescriptionError'), { count: MIN_DESCRIPTION_LENGTH }))
      }
    }

    if (uiStore.ticketTypeValue === TicketType.roomLayout) {
      if (uiStore.invalidPhotos) {
        errors.push(i18next.t(getSharedKey('invalidPhotos')))
      }
    }

    if (uiStore.invalidVideoUrl) {
      errors.push(i18next.t(getKey('ticketInvalidUrl')))
    }

    return this.hasNotErrors(errors)
  }
}

export const validateTicketForm = new ValidateTicketForm()
